import { useMemo } from 'react';

import {
  ExperienceFragmentResponse,
  ExperienceFragmentSchema,
} from '../../api/ExperienceFragment/eula.schema';
import { GetEULAStatus, useGetExperienceFragment } from '../../api/ExperienceFragment/query';
import { buildEulaTaxonomy, buildEulaUrl } from './helpers';
import { EulaTaxonomy } from './types';
import { useLocale } from '../AssetService/useLocale';

export interface EulaResult {
  content: EulaTaxonomy | undefined;
  status: GetEULAStatus;
  error: unknown;
}

export function useEula(): EulaResult {
  const { current, fallback } = useLocale();

  const primaryUrl = buildEulaUrl(current);
  const fallbackUrl = buildEulaUrl(fallback);

  const { data, status, error } = useGetExperienceFragment<ExperienceFragmentResponse>({
    primaryUrl,
    fallbackUrl,
    schema: ExperienceFragmentSchema,
  });

  const content = useMemo(() => {
    if (!data) return undefined;
    return buildEulaTaxonomy(data);
  }, [data]);

  return { content, status, error };
}
